import { makeUseVisualState } from '../../motion/utils/use-visual-state.mjs';
import { scrapeMotionValuesFromProps } from './utils/scrape-motion-values.mjs';
import { createHtmlRenderState } from './utils/create-render-state.mjs';

var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createHtmlRenderState,
    }),
};

export { htmlMotionConfig };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/html/config-motion.mjs
// module id = BIdD
// module chunks = 0